<div class="animated fadeInRight">
    <!-- MENU DE TITULOS -->
    <app-lfsa-card-v2
      [titulo]      = "DAT_TITULOS.titulo"
      [modulo]      = "GLOBAL_TITULOS.modulo"
      [tituloCard]  = "DAT_TITULOS.tituloCardList"
      [innTemplate] = "enviarTemplateEdit"
      [innTemplateButton]="innTemplateButton">
    </app-lfsa-card-v2>
    <!-- MENU DE TITULOS -->
  
    <!-- OPCIONES BOTONES IZQUIERDO -->
    <ng-template #innTemplateButton>
      <div class="col-md-6 mb-2">
        <div class="pagetitle">
          <div class="btn-group-justified btn-group" style="float: right;">
            <!-- <button (click)="nuevo()" class="btn btn-primary"> <i aria-hidden="true" class="fa fa-plus"></i> Agregar </button>-->
          </div>
        </div>
      </div>
    </ng-template>
    <!-- OPCIONES BOTONES IZQUIERDO -->
  
    <!-- GRILLA -->
    <ng-template #enviarTemplateEdit>
      <div class="form-group col-md-12" *ngIf="!selected">
        <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter " (keyup)="onQuickFilterChanged() " #quickFilter />
        <br>
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
          <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"  
                            [id]      ="DAT_AG_GRID.id" 
                            [class]   ="DAT_AG_GRID.class" 
                            [ngStyle] ="DAT_AG_GRID.style" 
                            [rowData] ="rowData" 
                            [sideBar] ="true"
                            [columnDefs]="columnDefs"
                            [defaultColDef]="defaultColDef"
                            [rowHeight]="DAT_AG_GRID.rowHeight"
                            [pagination]="DAT_AG_GRID.pagination" 
                            [paginationPageSize]="DAT_AG_GRID.pagina"
                            [allowContextMenuWithControlKey]="true"
                            [frameworkComponents]="frameworkComponents" >
          </ag-grid-angular>
      </div>
      <!-- GRILLA [cellSelection]="true" -->
      
      <!-- Form en pantalla completa -->
      <div class="container-fluid" *ngIf="selected">
        <div class="card border-warning mb-3" >
          <div class="card-body">
            <h5 class="card-title" style="font-size: medium;">Viaje #  {{ selected?.idViaje }}</h5>
              <div class="row">
                <div class="col" style="font-size: smaller;">Proveedor: {{ selected?.proveedorNombre }}</div>
                <div class="col" style="font-size: smaller;">Placa: {{ selected?.placa }}  </div>
                <div class="col" style="font-size: smaller;">Contenedor: {{ selected?.furgon }}  </div>
                <div class="col" style="font-size: smaller;">Chofer: {{ selected?.choferNombre }}  </div>
              </div>
            </div>
        </div>
        <h5>Llenar Check Vehicular </h5><hr>
        <h6> Hora Inicio Proceso: {{fechaHoraIncio}} </h6><hr>
          <form [formGroup]="formulario" mat-dialog-content>
            <div class="form-check form-switch col-md-6 ms-md-auto align-middle">
              <input class="form-check-input" id="all" type="checkbox" [formControl]="checkTodos">
              <label class="form-check-label" for="all">MARCAR TODO SI</label>
            </div>
            <div *ngIf="this.selected?.tipoCarga == 1">
              <div class="row p-2" *ngFor="let opcion of listOpciones">
              <div class="col-md-6"><label for="{{ opcion.name }}"><span>{{ opcion.valor }}</span></label></div>
              <div class="col-md-6">
                <div class="input-group input-group-lg">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="{{ opcion.name }}" id="inline1_{{opcion.name}}" value=1 [formControlName]="opcion.name">
                      <label class="form-check-label" for="inline1_{{opcion.name}}">SI</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="{{ opcion.name }}" id="inline2_{{opcion.name}}" value=0 [formControlName]="opcion.name">
                      <label class="form-check-label" for="inline2_{{opcion.name}}">NO</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="{{ opcion.name }}" id="inline3_{{opcion.name}}" value=2 [formControlName]="opcion.name">
                      <label class="form-check-label" for="inline3_{{opcion.name}}">NA</label>
                    </div>
                  </div>
                </div>
                </div>
            </div>
            <hr>
            <!-- FORMULARIO DINAMICO -->
            <app-check-dinamico *ngIf="preguntasDinamicas.length > 0"
              [preguntas]="preguntasDinamicas" 
              [parentForm]="formulario">
            </app-check-dinamico>

            <div class="row">
              <div class="col-12 form-group">
                <label>Firma Requerida</label>
                  <canvas #canvas class="border-warning" (touchstart)="startDrawing($event)" (touchmove)="moved($event)" height="200" width="600" >
                  </canvas>
                  <p class="error-message" *ngIf="signatureNeeded">Firma es requerida</p>
                  <button (click)="clearPad()" class="btn btn-primary"> <i aria-hidden="true" class="fa fa-refresh"></i> Limpiar </button>
              </div>

              <div class="col mt-3">
                <label for="adjuntos" class="form-control-sm">Seleccione fotos</label>
                <input class="form-control" type="file" id="adjuntos" multiple accept=".jpg,.jpeg,.png" (change)="onFileSelected($event)" >
                <p *ngIf="errorArchivos" style="color: red;">{{ errorArchivos }}</p>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col form-group" *ngIf="this.selected?.tipoCarga == 1">
                  <app-lfsa-input formControlName="observacion" [label]="'* Observacion'" [id]="'observacion'" [control]="formulario.get('observacion')" 
                  [type]="'text'">
                  </app-lfsa-input>
              </div>
              <div class="col form-group">
                <label for="autoriza">Revisión Vehicular</label>
                <select class="form-control" formControlName="estado">
                  <option value="">-- Seleccione --</option>
                  <option value="REVISION_ACEPTADA" *ngIf="selected?.tipoCarga == 1">Aceptada</option>
                  <option value="REVISION_CONDICIONADA" *ngIf="selected?.tipoCarga == 1">Condicionada</option>
                  <option value="REVISION_RECHAZADA" *ngIf="selected?.tipoCarga == 1">Rechazada</option>
                  <option value="REVISION_OPERADOR_HABILITADA" *ngIf="selected?.tipoCarga == 2 && selected?.estado == 'REVISION_CALIDAD_HABILITADA'">Revision Operador</option>
                  <option value="ANDEN_ASIGNADO" *ngIf="selected?.estado == 'REVISION_OPERADOR_HABILITADA'">Asignar área carga/descarga</option>
                  <option value="REVISION_EXCEPCION" *ngIf="false">Excepcion</option>
                </select>
                <small *ngIf="formulario.controls['estado'].errors && formulario.controls['estado'].touched" class="text-danger">*Este campo es inválido</small>
              </div>
            </div>

            <app-lfsa-botones-formulario 
                (devolverAccion)    = "acciones( $event )" 
                [formularioValido]  = "formulario.invalid" 
                [loading]="loading" [textBoton]="'Guardar'" class="row p-3">
            </app-lfsa-botones-formulario>
          </form>
      </div>

    </ng-template>

  </div>
  
  <!-- MODAL
  <app-lfsa-modal [innTemplate] = "abrirModal" [classModal] = "'modal-dialog modal-lg'" [idButton] = "'abrirModal'" [idClose] = "'cerrarModal'" [titulo] = "titleModal">
  </app-lfsa-modal>
    
  <ng-template #abrirModal>
    <div class="container-fluid">
      <div class="card border-warning mb-3" >
        <div class="card-body">
          <h5 class="card-title" style="font-size: medium;">Viaje #  {{ selected?.idViaje }}</h5>
            <div class="row">
              <div class="col" style="font-size: smaller;">Proveedor: {{ selected?.proveedorNombre }}</div>
              <div class="col" style="font-size: smaller;">Placa: {{ selected?.placa }}  </div>
            </div>
          </div>
      </div>
      <h5>Llenar Check Vehicular </h5><hr>
      <h6> Hora Inicio Proceso: {{fechaHoraIncio}} </h6><hr>
        <form [formGroup]="formulario" mat-dialog-content>
          <div class="form-check form-switch col-md-6 ms-md-auto align-middle">
            <input class="form-check-input" id="all" type="checkbox" [formControl]="checkTodos">
            <label class="form-check-label" for="all">MARCAR TODO SI</label>
          </div>

          <div class="row p-2" *ngFor="let opcion of listOpciones">
            <div class="row col"><label for="{{ opcion.name }}"><span>{{ opcion.valor }}</span></label></div>
            <div class="col input-group input-group-lg">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="{{ opcion.name }}" id="inline1_{{opcion.name}}" value=1 [formControlName]="opcion.name">
                <label class="form-check-label" for="inline1_{{opcion.name}}">SI</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="{{ opcion.name }}" id="inline2_{{opcion.name}}" value=0 [formControlName]="opcion.name">
                <label class="form-check-label" for="inline2_{{opcion.name}}">NO</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="{{ opcion.name }}" id="inline3_{{opcion.name}}" value=2 [formControlName]="opcion.name">
                <label class="form-check-label" for="inline3_{{opcion.name}}">NA</label>
              </div>
            </div>
          </div>
          <hr>

          <div class="row">
            <div class="col-3 form-group">
              <label></label>
              <div class="form-check form-switch">
                <input class="form-check-input" formControlName="firma" id="firma" type="checkbox">
                <label class="form-check-label" for="firma">Requiere Firmar</label>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col form-group">
                <app-lfsa-input formControlName="observacion" [label]="'* Observacion'" [id]="'observacion'" [control]="formulario.get('observacion')" 
                [type]="'text'">
                </app-lfsa-input>
            </div>
            <div class="col form-group">
              <label for="autoriza">Revisión Vehicular</label>
              <select class="form-control" formControlName="estado">
                <option value="">-- Seleccione --</option>
                <option value="REVISION_ACEPTADA">Aceptada</option>
                <option value="REVISION_CONDICIONADA">Condicionada</option>
                <option value="REVISION_RECHAZADA">Rechazada</option>
              </select>
              <small *ngIf="formulario.controls['estado'].errors && formulario.controls['estado'].touched" class="text-danger">*Este campo es inválido</small>
            </div>
          </div>

          <app-lfsa-botones-formulario 
              (devolverAccion)    = "acciones( $event )" 
              [formularioValido]  = "formulario.invalid" 
              [loading]="loading" [textBoton]="'Guardar'" class="row p-3">
          </app-lfsa-botones-formulario>
        </form>
    </div>
  </ng-template> -->
  <!-- END MODAL --> 
